/**
 * @license CKCode
 * Copyright 2023 CourseKata
 * SPDX-License-Identifier: GPL-3.0-or-later
 */
import { css } from "lit";
export const styles = css `
  /* prettier-ignore */
  :host {
    /* typography */
    --_font-family: var(
      --ckc-output-area-font-family,
      var(--ckc-font-family, var(--md-sys-typeface-body-medium-font, Helvetica, Arial, sans-serif))
    );
    --_font-weight: var(
      --ckc-output-area-font-weight,
      var(--ckc-font-weight, var(--md-sys-typescale-body-medium-weight, normal))
    );
    --_font-size: var(
      --ckc-output-area-font-size,
      var(--ckc-font-size, var(--md-sys-typescale-body-medium-size, 1rem))
    );

    --_font-family-mono: var(
      --ckc-font-family-mono,
      "Fira Code", monospace
    );
    --_font-weight-mono: var(
      --ckc-font-weight-mono,
      var(--md-sys-typescale-body-medium-weight, normal)
    );
    --_font-size-mono: var(
      --ckc-font-size-mono,
      calc(var(--md-sys-typescale-body-medium-size, 1rem) * 0.9)
    );

    /* layout */
    --_padding: var(
      --ckc-output-area-padding,
      calc(var(--ckc-padding, 1rem))
    );
    --_border-radius: var(
      --ckc-output-area-border-radius,
      var(--ckc-border-radius, 4px)
    );

    /* elevation */
    --_box-shadow-inset: var(
      --ckc-output-area-box-shadow,
      var(
        --ckc-box-shadow-inset,
        inset 2px 2px 6px rgba(0, 0, 0, 0.08),
        inset -2px -2px 6px rgba(0, 0, 0, 0.03)
      )
    );

    /* colors */
    --_color-info-container: var(
      --ckc-output-area-color-info-container,
      var(--md-sys-color-primary-container, #f5f5f5)
    );
    --_color-on-info-container: var(
      --ckc-output-area-color-on-info-container,
      var(--md-sys-color-on-primary-container, #000000)
    );
    --_color-error-container: var(
      --ckc-output-area-color-error-container,
      var(--ckc-color-error-container, var(--md-sys-color-error-container, #ffcccc))
    );
    --_color-on-error-container: var(
      --ckc-output-area-color-on-error-container,
      var(--ckc-color-on-error-container, var(--md-sys-color-on-error-container, #000000))
    );
    --_color-outline: var(
      --ckc-output-area-color-outline,
      var(--ckc-color-outline, var(--md-sys-color-outline, #333333))
    );
  }

  :host {
    display: block;
    border-radius: var(--_border-radius);
    max-height: 800px;
    overflow-y: auto;
  }

  :host > main {
    /** typography */
    font-family: var(--_font-family);
    font-weight: var(--_font-weight);
    font-size: var(--_font-size);
    word-wrap: normal;

    /** layout */
    position: relative;
    display: flex;
    flex-direction: column;
    gap: calc(var(--_padding) / 2);

    /* gap: calc(var(--_padding) / 2); */
    border-radius: var(--_border-radius);
  }

  :host(.high-contrast) > main {
    border: 1px solid black;
  }

  :host > main:focus-visible {
    outline-color: var(--_color-outline);
  }

  .output-item-wrapper {
    box-shadow: var(--_box-shadow-inset);
    border-radius: var(--_border-radius);
    overflow: scroll;
  }

  .output-item {
    padding: var(--_padding);
    border-radius: var(--_border-radius);
    overflow: scroll;
  }

  .output-item--info,
  .output-item--error {
    margin-top: 0;
    padding-top: var(--_padding);
  }

  .output-item--info {
    color: var(--_color-on-info-container);
    background-color: var(--_color-info-container);
  }

  .output-item--error {
    color: var(--_color-on-error-container);
    background-color: var(--_color-error-container);
  }

  pre,
  code {
    font-family: var(--_font-family-mono);
    font-weight: var(--_font-weight-mono);
    font-size: var(--_font-size-mono);
  }

  pre {
    overflow: auto;
    margin: 0;
    padding: 0;
  }

  p {
    margin: 0;
  }

  img {
    max-width: 100%;
  }

  table.dataframe {
    border-collapse: collapse;
    border: 1px solid var(--_color-outline);
    border-radius: var(--_border-radius);
    font-size: 0.9rem;
  }

  table.dataframe td,
  table.dataframe th {
    border: 1px solid rgba(0, 0, 0, 0.05);
    padding: calc(var(--_padding) / 2);
  }

  table.dataframe td {
    text-align: center;
  }

  table.dataframe > tr:nth-child(even),
  table.dataframe tbody tr:nth-child(even) {
    background: rgba(0, 0, 0, 0.05);
  }

  table.dataframe > tr:hover,
  table.dataframe tbody tr:hover {
    background: var(--md-sys-color-primary-container, #d5e2ff);
  }

  table.dataframe caption {
    padding: calc(var(--_padding) / 2);
  }

  .dl-inline > dt {
    font-weight: bold;
  }

  .dl-inline > dt:not(:first-of-type) {
    margin-inline-start: 0.5em;
  }

  .dl-inline > dd {
    margin: 0;
  }
`;
//# sourceMappingURL=styles.css.js.map